import "@hotwired/turbo-rails"
import "./controllers"
import "bootstrap/js/dist/alert"
import "trix"
import "@rails/actiontext"
import "./lib/turbo_cache"
